require('./search.module');
require('./controllers/climber.controller');
require('./controllers/club.controller');
require('./controllers/alpclub.controller');
require('./controllers/camp.controller');
require('./directives/search-block/search-block.directive');
require('./controllers/instructor.controller');

